'use strict'

var pageType = pageType || {}
var $ = jQuery

/* INIT
 ----------------------------------------------------------------------------------------------------------------------*/
pageType.init = function () {
  pageType.animation()

  Drupal.behaviors.animation = {
    attach: function (context, settings) {
      pageType.animation()
    },
  }
}

/* DOM READY
 ----------------------------------------------------------------------------------------------------------------------*/
$(pageType.init)

/* FUNCTIONS
 ----------------------------------------------------------------------------------------------------------------------*/
// Animate content in Page type
pageType.animation = function () {

  // console.log('pageType');
  // Page type alias standard page
  var pageType = $('.page--standard-page')
  // Var for left menu TOC
  var navTabs = pageType.find('.nav-tabs')
  var tocHeadingLink = navTabs.find('.paragraph--type--section-heading')
  var tocAccordionLink = navTabs.find('.paragraph--type--accordion-item')
  // Vars for content paragraph
  var tabContent = pageType.find('.tab-content')
  var tabPane = tabContent.find('.tab-pane')
  var tabPaneFC = tabContent.find('.tab-pane:first-child')
  var accordionParagraph = tabContent.find('.paragraph--type--accordion-item')
  // Get anchor url
  var anchor = decodeURIComponent(window.location.hash.substr(1))

  // Activate first tab pane by default
  tabPaneFC.addClass('active show')

  // Get and wrap accordion links in left menu TOC
  tocHeadingLink.each(function (index) {
    $(this).
      nextUntil('.paragraph--type--section-heading').
      wrapAll('<div class=\'accordion-links\'></div>')
  })
  // Show/hide accordion links following tabs menu link active in left menu TOC
  tocHeadingLink.click(function () {
    $('.accordion-links').removeClass('show')
    $(this).
      next('.accordion-links').
      toggleClass('show').
      siblings().
      removeClass('show')
    $(this).next('.accordion-links').addClass('show')
  })
  tocHeadingLink.on('shown.bs.tab', function (e) {
    $(this).next('.accordion-links').addClass('show')
  })

  // Get and wrap all elements between 2 tab pane paragraph
  tabPane.each(function (index) {
    $(this).
      nextUntil('.tab-pane').
      wrapAll('<div id=\'accordion\' class=\'accordion-paragraphs\'></div>')
  })

  // Moove all elements between 2 tab pane paragraph in the tab pane paragraph
  // before
  $('.accordion-paragraphs').each(function (index) {
    $(this).appendTo($(this).prev('.tab-pane'))
  })

  // Get nav link with anchor data name
  var navLink = navTabs.find('.nav-link').
    filter('[data-name="' + anchor + '"]')
  // open tab if anchor url exist
  if (navLink.length > 0) {
    navLink.tab('show')
  }

  // activate accordion menu and open related accordion paragrahp based on
  // anchor url
  var tocAccordionLinkLoc = tocAccordionLink.filter(
    '[data-name="' + anchor + '"]')
  if (tocAccordionLinkLoc.length > 0) {
    tocAccordionLinkLoc.parent().prev('.nav-link').tab('show')
    tocAccordionLinkLoc.addClass('active')
  }

  // open accordion if anchor url exist
  var accordionParagraphAnchor = accordionParagraph.filter(
    '[id="' + anchor + '"]')
  if (accordionParagraphAnchor.length > 0) {
    accordionParagraphAnchor.find('.field--field-rich-text').collapse('show')
    accordionParagraphAnchor.addClass('active')
  }

  //  Open accordion paragraph on menu left TOC click link
  tocAccordionLink.click(function () {
    // Menu TOC
    var tocAccordionLinkDn = $(this).attr('data-name')
    // Content
    var accordionParagraphId = accordionParagraph.filter(
      '[id="' + tocAccordionLinkDn + '"]')
    if (accordionParagraphId.length > 0) {
      accordionParagraphId.find('.field--field-rich-text').collapse('show')
    }
  })

  // scroll to active heading section paragraph onload window
  // window.onload = function () {
  //   if (tabPane.hasClass('active')) {
  //     $('html,body').animate({
  //       scrollTop: tabPane.offset().top,
  //     }, 'slow')
  //   }
  // }

  // Activate class on menu toc when accordion close/open
  $(accordionParagraph).on('shown.bs.collapse', function () {
    var paragID = this.id
    var accordLinkDN = tocAccordionLink.filter('[data-name="' + paragID + '"]')
    accordLinkDN.addClass('active')
    $('html,body').animate({
      scrollTop: $(this).offset().top - 10,
    }, 'slow')
  })
  $(accordionParagraph).on('hidden.bs.collapse', function () {
    var paragID = this.id
    var accordLinkDN = tocAccordionLink.filter('[data-name="' + paragID + '"]')
    accordLinkDN.removeClass('active')
  })

  // Reload page on main menu anchor links click
  $('.page--standard-page .block--menu a.is-active').click(function () {
    location.href = this.href
    location.reload(true)
  })



}
